import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const BackgroundRedLine = () => (
  <div>
    <div className="w-full hidden sm:block">
      <StaticImage
        className="w-full"
        src="../static/images/icon/background-red-line.svg"
        alt="background-red-line"
        formats={["auto", "webp", "avif"]}
      />
    </div>
    <div className="w-screen sm:hidden">
      <StaticImage
        className="w-full"
        src="../static/images/icon/redline-mobile-1.svg"
        alt="redline"
      />
    </div>
  </div>
)

export default BackgroundRedLine
